import { History } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { Order as OrderType } from '../../apiTypes';

import OrderHistory from './OrderHistory';

const colorMap = {
  income: 'success.main',
  spending: 'error.main',
  transfer: 'warning.main',
  cancel: 'warning.main',
};

type Props = {
  order: DbDocument<OrderType>;
};

const OrderHistoryButton = ({ order }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <History />
      </IconButton>

      {open && <OrderHistory order={order} onClose={() => setOpen(false)} />}
    </>
  );
};

export default OrderHistoryButton;
